// client/src/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5050';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// ✅ Interceptor to attach Bearer token automatically
api.interceptors.request.use(
  (config) => {
    // Skip adding token for /auth routes
    if (config.url && config.url.startsWith('/auth')) {
      return config;
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('[api] No token found in localStorage');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
